import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { GridStateType, ApiGetDataStatus } from '@redux/types'

// initial state
const initialState: GridStateType = {
	// grid status
	status: 'init',

	// gird command
	gridCommandError: [],
}

const slice = createSlice({
	name: 'grid',
	initialState,
	reducers: {
		// grid status
		STATUS: (state: GridStateType, action: PayloadAction<ApiGetDataStatus>) => {
			state.status = action.payload
		},

		// gird command
		GRID_COMMAND_ERROR: (
			state: GridStateType,
			action: PayloadAction<GridStateType['gridCommandError']>,
		) => {
			state.gridCommandError = action.payload
		},
	},
})

export const gridActions = slice.actions
export default slice.reducer
